Ext.define('SA.model.LocationPredicates', {
    constructor({censusReleaseYear, geoUnits, predicates}) {
        this.censusReleaseYear = censusReleaseYear;
        this.geoUnits = geoUnits;
        this.predicates = predicates;
    },

    filter(locations) {
        return locations.filter(location => this.test(location));
    },

    test(location) {
        var censusReleaseYear = this.censusReleaseYear,
            geoUnits = this.geoUnits;

        return this.predicates.every(predicate => predicate.test({censusReleaseYear, geoUnits, location}));
    },

    testValue(locationValue) {
        return this.test(SA.data.LocationsCache.getModel(locationValue));
    }
});